export default __webpack_public_path__ + "images/react/components/experiences/pricing-pages-editors/assets/loader-pricing-page-mockup.svg";